import type { FaireProductEntity } from "../../entity_types/product";

export const p_kuxdynrtwa: FaireProductEntity = {
  token: "p_kuxdynrtwa",
  type: "product",
  name: "Magnesium L-Threonate Complex with Apigenin and L-theanine",
  brandToken: "b_7jx4czv7nc",
  brandName: "WhyNotNatural",
  imageUrl:
    "https://cdn.faire.com/fastly/c3a21f12b7df8554d411a829db65ee732e913d243bc5df1ef7e887a34a47f561.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ab02d9206e35fa24135e6119e8f8316f4fb831e328b75ee0535054f0067f481b.jpeg",
    "https://cdn.faire.com/fastly/1a90bcfdc26d82d08ee07fa0ad326ba6f8195f2cf9a56f4ba0a78a1258c91d02.jpeg",
    "https://cdn.faire.com/fastly/86ca7227f3abb0542bb79c356597c071cd4f6776b934ec4ea600f58f58e89bc4.jpeg",
    "https://cdn.faire.com/fastly/1fa1adff162361e52a3c1ced62f3b8d8bf90b948a3c76f690478cbb97974c254.jpeg",
    "https://cdn.faire.com/fastly/720536310820757b41042af65ae01da28f86e4e49cae92b858513587acc2ead2.jpeg",
  ],
  priceDollars: 14.98,
  description:
    "COGNITIVE FUNCTION: studies have shown Magtein magnesium l-threonate is a form of magnesium that can cross the blood-brain barrier to a greater extent allowing it to increase the magnesium level in the brain which can improve memory and learning abilities as well as synaptic plasticity. L-theanine increases alpha brain wave activity, creating a relaxed but calm and focused mental state. NEUROPROTECTIVE: magnesium l-threonate is considered the most protective form for the brain and apigenin can protect neurons from damage and support brain health. All three ingredients potentially lower the risk of cognitive decline and neurodegeneration due to their antioxidant and brain protective qualities. SLEEP QUALITY IMPROVEMENT: magnesium l-threonate relaxes and calms nervous system which allows deeper sleep while l-theanine promotes relaxation and apigenin has been studies for its anxiolytic properties including relaxation. STRESS REDUCTION: both l-theanine and apigenin are calming compounds th",
  tags: [],
  msrpDollars: 29.97,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:13.578Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
